<mat-form-field>
	<mat-select class="header-countries--lang"
							panelClass="header-languages" disableOptionCentering
							(selectionChange)="languageChanged()"
							[formControl]="languageControl">
		<mat-select-trigger>
			{{ languageControl.value | uppercase | truncate:['5',''] }}
		</mat-select-trigger>
		<mat-option *ngFor="let lang of availableLangs"
								[value]="lang.value"
								[defTrackEvent]="{ category: 'Global Navbar', action: 'Choose a language', label: lang.label }">
			{{ lang.label | defNeutralizeCountryName }}
		</mat-option>
	</mat-select>
</mat-form-field>
